import { Flex } from 'antd';
import React, { useContext, useState, useEffect } from "react";
import { HouseLineIcon } from "@phosphor-icons/react";
import { VscNewFolder } from "react-icons/vsc";
import { IoIosLock, IoIosUnlock } from "react-icons/io";
import { BsShieldFillCheck, BsShieldFillExclamation, BsShieldLockFill } from "react-icons/bs";
import { useViewerStore } from '../../../../store/store';
import { usePrimaryColor } from '../../../../contexts/ThemeColorContext';
import { ThemeContext } from '../../../../contexts/ThemeContext';
import { DesignData } from '../../../../@types/types';
import {isEnFinLossesVendor} from '../../../../Constants';

interface InactiveDesignListProps {
    onSelectDesign: (data: DesignData) => void;
}

const InactiveDesignList: React.FC<InactiveDesignListProps> = ({ onSelectDesign}) => {

    const { oldDesignList, isloadingOldDesignList, selectedDesignIndex} = useViewerStore();
    const primaryColor = usePrimaryColor();
    const { theme } = useContext(ThemeContext);
    const [toggle, setToggle] = useState(false);
    const [selectedDesignIdx, setSelectedDesignIdx] = useState(selectedDesignIndex);
    const stage = sessionStorage.getItem('currentStage');

    const toggleDesign = () => setToggle(!toggle);
    const onClickDesign = async (index: number) => {
        setSelectedDesignIdx(index);
        onSelectDesign(oldDesignList[index] || []);
    };

    const getLocalTime = (isoString: string) => {
        const globalTime = new Date(isoString);
        const localTime = new Date(globalTime.getTime() - (globalTime.getTimezoneOffset() * 60000));
        return localTime?.toLocaleString();
    }

    const getHouseIconDefaultColor = (): string => {
        return theme === 'dark' ? '#ffffff' : '#000000';
    };

    return (
        <Flex vertical>
            <div className={`building-selection-dropdown user__design--toggle ${toggle ? 'active' : ''}`} onClick={toggleDesign}>
                <VscNewFolder size={24} />
                <span className='user__label'>Designs</span>
            </div>
            <div className={`user__inactive-design--menu menu`}>
                <ul className='user__inactive-design--menu-list'>
                    {
                        isloadingOldDesignList ? (
                            <li className="menu__item" style={{ color: '#aaa', padding: '10px' }}>Loading designs...</li>
                        ) : oldDesignList.length === 0 ? (
                            <li className="menu__item" style={{ color: '#aaa', padding: '10px' }}>No designs found</li>
                        ) : oldDesignList.map((design, index) => {

                            return (
                                <li key={index}
                                    className={`menu__item ${selectedDesignIdx == index && 'active'}`}
                                    onClick={() => onClickDesign(index)}>
                                    <HouseLineIcon size={18} color={selectedDesignIdx == index ? primaryColor : getHouseIconDefaultColor()} />
                                    <div style={{
                                        display: "flex",
                                        flexDirection: "column",
                                        width: "180px"
                                    }}>
                                        <span
                                            className='menu__label'>Design : {design.Design_No} - Version : {design.Version_No}</span>
                                        <span>{design.User_Created_Id} - {design.User_Department}
                                            {design.Active_Ind ? "" : design.Design_Certification_Status !== "Not Certified" && design.Design_Certification_Status !== null ? " - Not Active" : ""}
                                        </span>
                                        <span>{getLocalTime(design.User_Created_Timestamp)}</span>
                                        <span>Size: {design.System_Size_kWdc ?? 0} kW DC</span>
                                        {isEnFinLossesVendor(design.MultipliersVendor) && (
                                            <span>Losses: EnFin</span>
                                        )}
                                        {Number(stage) >= 4 && Number(stage) <= 10 && design.Design_Certification_Status !== "Not Certified" && design.Design_Certification_Status !== null && (
                                            <div
                                                className={`certify ${selectedDesignIdx == index && 'active'}`}> {design.Design_Certification_Status}
                                                {design.Design_Certification_Status === "As-Built Certified"
                                                    ? <BsShieldLockFill size={14} style={{ marginLeft: "10px" }} color='#5aac5a' />
                                                    : design.Design_Certification_Status === "Certified Design Override"
                                                        ? <BsShieldFillExclamation size={14} style={{ marginLeft: "10px" }} color='#ca4a4a' />
                                                        : design.Design_Certification_Status === "Pre-Install Certified"
                                                            ? <BsShieldFillCheck size={14} style={{ marginLeft: "10px" }} color='#dadada' />
                                                            : <BsShieldFillCheck size={14} style={{ marginLeft: "10px" }} color='#ffb300' />}
                                            </div>
                                        )}

                                    </div>
                                    {design.Design_Certification_Status !== "Not Certified" && design.Design_Certification_Status !== null && (
                                        <div className={`lock-design ${selectedDesignIdx === index && 'active'}`}>
                                            {design.Design_Certification_Status === "Certified Design Override" ?
                                                <IoIosUnlock size={25} /> : <IoIosLock size={25} />}
                                        </div>
                                    )}
                                </li>
                            )
                        })
                    }
                </ul>
            </div>
        </Flex>
    );
};

export default InactiveDesignList;




